var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonTooltip',{attrs:{"icon":"","color":"rgba(0, 0, 0, 0.54)","x-small":"","icon-name":"fa-house","tooltip-text":"Home","href":`/`}})
}
var staticRenderFns = []

export { render, staticRenderFns }